import { render, staticRenderFns } from "./ShopProductsTab.vue?vue&type=template&id=59d481d0&"
import script from "./ShopProductsTab.vue?vue&type=script&lang=js&"
export * from "./ShopProductsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports